import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { NotificationContainer } from "react-notifications";

import Header from "./Header";
import Home from "../Home";
import UserAdmin from "../Users";
import TagsAdmin from "../Tags";
import Exhibits from "../Exhibits";
import ManageExhibit from "../ManageExhibit";
import ManageArtifacts from "../Artifacts";

import Login from "../Login";

import AuthRoute from "../../AuthRoute";

const Main = () => {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />

      <div>
        <Header />

        <div className="container" style={{ paddingTop: 30 }}>
          <NotificationContainer />
          <AuthRoute exact path="/" component={Home} />
          <AuthRoute exact path="/users" component={UserAdmin} />
          <AuthRoute exact path="/tags" component={TagsAdmin} />
          <AuthRoute exact path="/exhibits" component={Exhibits} />
          <AuthRoute exact path="/manage/:id?" component={ManageExhibit} />
          <AuthRoute exact path="/artifacts/:id" component={ManageArtifacts} />
        </div>
      </div>
    </Switch>
  );
};

export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/pages/Main/index.jsx